import { Component, NgModule, ViewChild } from '@angular/core';
import { DataGridModule, DialogModule, FileUploadModule, PanelModule } from 'primeng/primeng';
import { SiteBrowserState } from '../../core/util/site-browser.state';
import { FileService } from '../../core/file/file.services';
import { SiteBrowserService } from '../../core/util/site-browser.service';
import { SettingsStorageService } from '../../core/util/settings-storage.service';
import { FolderService } from '../../core/util/folder.service';
import { FileSearchService } from '../../core/file/file-search.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
var SiteDatagridComponent = (function () {
    function SiteDatagridComponent(updateService, fileService, siteBrowserService, settingsStorageService, folderService, fileSearchService) {
        var _this = this;
        this.updateService = updateService;
        this.fileService = fileService;
        this.siteBrowserService = siteBrowserService;
        this.settingsStorageService = settingsStorageService;
        this.folderService = folderService;
        this.fileSearchService = fileSearchService;
        this.dotCMSURL = '';
        this.uploadedFiles = [];
        if (settingsStorageService.getSettings()) {
            this.dotCMSURL = settingsStorageService.getSettings().site;
        }
        this.site = updateService.getSelectedSite();
        if (updateService.getURI()) {
            this.loadFolder(updateService.getURI());
        }
        updateService.currentSite
            .subscribe(function (site) {
            if (site) {
                _this.loadSite(site);
            }
        });
        fileSearchService.searchQuery
            .subscribe(function (searchQuery) {
            if (searchQuery && searchQuery.trim() !== '') {
                updateService.changeURI(null);
                _this.loadSearchResults(searchQuery);
            }
            else {
                if (updateService.getSelectedFolder() != null && updateService.getSelectedFolder().trim() !== '') {
                    if (updateService.getURI()) {
                        _this.loadFolder(updateService.getURI());
                    }
                }
                else {
                    if (updateService.getSelectedSite()) {
                        _this.loadSite(updateService.getSelectedSite());
                    }
                }
            }
        });
        updateService.currentURI
            .subscribe(function (uri) {
            if (uri) {
                _this.loadFolder(uri);
            }
        });
        setTimeout(function () {
        }, 100);
    }
    SiteDatagridComponent.prototype.ngOnInit = function () {
    };
    SiteDatagridComponent.prototype.loadSearchResults = function (searchQuery) {
        var _this = this;
        if (searchQuery !== null && searchQuery.trim().length > 0) {
            searchQuery.trim();
            searchQuery = searchQuery + '*';
            searchQuery = searchQuery.split(' ').join('* ');
            searchQuery = '+baseType:4%20+(' + (this.site && this.site.identifier ? 'conhost:' + this.site.identifier : '') + '%20conhost:SYSTEM_HOST)%20+deleted:false%20+working:true%20+_all:(' + searchQuery + ')/orderby/modDate%20desc';
            this.fileSearchService.search(searchQuery)
                .subscribe(function (treeables) { return _this.treeables = treeables; });
            setTimeout(function () {
            }, 100);
        }
    };
    SiteDatagridComponent.prototype.loadFolder = function (uri) {
        var _this = this;
        this.siteBrowserService.getTreeableAssetsUnderFolder(this.site.hostname, uri)
            .subscribe(function (treeables) { return _this.treeables = treeables; });
        setTimeout(function () { }, 100);
    };
    SiteDatagridComponent.prototype.loadSite = function (site) {
        var _this = this;
        this.site = site;
        this.siteBrowserService.getTreeableAssetsUnderSite(site.hostname)
            .subscribe(function (treeables) { return _this.treeables = treeables; });
        setTimeout(function () { }, 100);
    };
    SiteDatagridComponent.prototype.selectTreeable = function (treeable) {
        this.updateService.changeURI(treeable.path);
    };
    SiteDatagridComponent.prototype.displayDetails = function (file) {
        this.displayDialog = true;
        this.selectedFile = file;
    };
    SiteDatagridComponent.prototype.displayUpload = function (file) {
        this.uploadDialog = true;
    };
    SiteDatagridComponent.prototype.onDialogHide = function () {
        this.selectedFile = null;
    };
    SiteDatagridComponent.prototype.onUploadHide = function () { };
    SiteDatagridComponent.prototype.addFileToUpload = function (e) {
        for (var _i = 0, _a = e.files; _i < _a.length; _i++) {
            var file = _a[_i];
            this.uploadedFiles.push(file);
        }
    };
    SiteDatagridComponent.prototype.clearUploads = function (e) {
        this.uploadedFiles = [];
    };
    SiteDatagridComponent.prototype.onUpload = function (e) {
        var _this = this;
        var uri = this.updateService.getURI();
        this.folderService.loadFolderByURI(this.site.hostname, uri)
            .subscribe(function (folder) { return _this.uploadIntoFolder(folder, e.files); });
        setTimeout(function () { }, 100);
        return;
    };
    SiteDatagridComponent.prototype.uploadIntoFolder = function (folder, files) {
        var _this = this;
        var fileContentTypeID = folder.defaultFileType;
        for (var i = 0; i < files.length; i++) {
            var file = files[i];
            this.fileService.uploadFile(file, folder.path, fileContentTypeID);
        }
        console.log('Uploaded all files');
        this.uploadedFiles = [];
        this.fieldUpload.clear();
        this.uploadDialog = false;
        // Needs to be updated so the file service returns errors and messages and then load on sucussfull upload
        setTimeout(function () {
            _this.loadFolder(_this.updateService.getURI());
        }, 2000);
        setTimeout(function () {
            _this.loadFolder(_this.updateService.getURI());
        }, 2000);
        setTimeout(function () {
            _this.loadFolder(_this.updateService.getURI());
        }, 2000);
    };
    return SiteDatagridComponent;
}());
export { SiteDatagridComponent };
SiteDatagridComponent.decorators = [
    { type: Component, args: [{
                selector: 'site-datagrid',
                styles: [require('./../app.css')],
                template: "\n    <p-dataGrid [value]=\"treeables\" [paginator]=\"true\" [rows]=\"20\" [alwaysShowPaginator]=\"false\">\n      <ng-template let-treeable pTemplate=\"item\">\n        <div style=\"padding:3px\" class=\"ui-g-12 ui-md-3\">\n          <p-panel [style]=\"{'text-align':'center'}\">\n            <span [ngSwitch]=\"treeable.type\">\n              <span *ngSwitchCase=\"'folder'\" class=\"\">\n                <a (click)=\"selectTreeable(treeable)\"><img src=\"assets/folder.png\"></a>\n              </span>\n              <span *ngSwitchCase=\"'file_asset'\">\n                <a (click)=\"displayDetails(treeable)\">\n                  <img *ngIf=\"treeable.isImage() && treeable.extension!='ico'\" src=\"{{dotCMSURL}}/contentAsset/image/{{treeable.inode}}/fileAsset/filter/Thumbnail/thumbnail_w/48/thumbnail_h/48/byInode/true\">\n                  <span *ngIf=\"!treeable.isImage() || treeable.extension=='ico'\" class=\"\" aria-hidden=\"true\">\n                    <img src=\"assets/file.png\">\n                  </span>\n                </a>\n              </span>\n            </span>\n            <div class=\"treeable-detail\">{{treeable.title}}</div>\n          </p-panel>\n        </div>\n      </ng-template>\n    </p-dataGrid>\n    <p-dialog header=\"File Details\" [closable]=\"true\" [(visible)]=\"displayDialog\" [responsive]=\"true\" showEffect=\"fade\" [modal]=\"true\" width=\"1040\" (onAfterHide)=\"onDialogHide()\">\n\n      <div class=\"ui-g\" *ngIf=\"selectedFile\">\n        <div class=\"ui-g-12 ui-md-7\">\n          <img *ngIf=\"selectedFile.isImage()\" src=\"{{dotCMSURL}}/contentAsset/image/{{selectedFile.inode}}/fileAsset/filter/Thumbnail/thumbnail_w/530/thumbnail_h/400/byInode/true\">\n          <img *ngIf=\"!selectedFile.isImage()\" src=\"{{dotCMSURL}}/dA/{{selectedFile.inode}}/225w\" onerror=\"this.style.display='none'\">\n        </div>\n        <div class=\"ui-g-12 ui-md-5\">\n          <div class=\"ui-g-3\"><label class=\"treeable-detail-label\">Inode</label></div>\n          <div class=\"ui-g-9\"><input class=\"treeable-detail-input\" id=\"inode\" type=\"text\" pInputText [disabled]=\"true\" [(ngModel)]=\"selectedFile.inode\" /></div>\n          <div class=\"ui-g-3\"><label class=\"treeable-detail-label\">Identifier</label></div>\n          <div class=\"ui-g-9\"><input class=\"treeable-detail-input\" id=\"identifier\" type=\"text\" pInputText [disabled]=\"true\" [(ngModel)]=\"selectedFile.identifier\" /></div>\n          <div class=\"ui-g-3\"><label class=\"treeable-detail-label\">Filename</label></div>\n          <div class=\"ui-g-9\"><input class=\"treeable-detail-input\" id=\"fileName\" type=\"text\" pInputText [disabled]=\"true\" [(ngModel)]=\"selectedFile.fileName\" /></div>\n          <div class=\"ui-g-3\"><label class=\"treeable-detail-label\">Title</label></div>\n          <div class=\"ui-g-9\"><input class=\"treeable-detail-input\" id=\"title\" type=\"text\" pInputText [disabled]=\"true\" [(ngModel)]=\"selectedFile.title\" /></div>\n          <div class=\"ui-g-3\"><label class=\"treeable-detail-label\">Edititor</label></div>\n          <div class=\"ui-g-9\"><input class=\"treeable-detail-input\" id=\"modUserName\" type=\"text\" pInputText [disabled]=\"true\" [(ngModel)]=\"selectedFile.modUserName\" /></div>\n          <div class=\"ui-g-3\"><label class=\"treeable-detail-label\">Path</label></div>\n          <div class=\"ui-g-9\"><input class=\"treeable-detail-input\" id=\"path\" type=\"text\" pInputText [disabled]=\"true\" [(ngModel)]=\"selectedFile.path\" /></div>\n          <div class=\"ui-g-3\"><label class=\"treeable-detail-label\">Mine Type</label></div>\n          <div class=\"ui-g-9\"><input class=\"treeable-detail-input\" id=\"mimeType\" type=\"text\" pInputText [disabled]=\"true\" [(ngModel)]=\"selectedFile.mimeType\" /></div>\n        </div>\n      </div>\n    </p-dialog>"
            },] },
];
/** @nocollapse */
SiteDatagridComponent.ctorParameters = function () { return [
    { type: SiteBrowserState, },
    { type: FileService, },
    { type: SiteBrowserService, },
    { type: SettingsStorageService, },
    { type: FolderService, },
    { type: FileSearchService, },
]; };
SiteDatagridComponent.propDecorators = {
    'fieldUpload': [{ type: ViewChild, args: ['fileUploadWidget',] },],
};
var DotSiteDatagridModule = (function () {
    function DotSiteDatagridModule() {
    }
    return DotSiteDatagridModule;
}());
export { DotSiteDatagridModule };
DotSiteDatagridModule.decorators = [
    { type: NgModule, args: [{
                declarations: [SiteDatagridComponent],
                exports: [SiteDatagridComponent],
                imports: [DialogModule, FileUploadModule, DataGridModule, CommonModule, PanelModule, FormsModule],
                providers: []
            },] },
];
/** @nocollapse */
DotSiteDatagridModule.ctorParameters = function () { return []; };
//# sourceMappingURL=site-datagrid.component.js.map